var stickerGenerator;

module.exports = stickerGenerator = {

    init: function() {
      stickerGenerator.stickerHandler();
    },

    stickerHandler: function () {
      
      var sticker = document.querySelectorAll('.js-product-sticker'),
          thisSticker;

      for(var i=0;i < sticker.length;i++) {
        thisSticker = sticker[i];
        thisSticker.style.color           = thisSticker.dataset.color;
        thisSticker.style.backgroundColor = thisSticker.dataset.background;
        thisSticker.classList.add('dkt-product__sticker--visible');
      }
    },
};


// WEBPACK FOOTER //
// ./src/modules-es5/commons/components/sticker-generator.js